import { AutogenLayoutRatewareTariffCodeList } from "./autogen/AutogenLayoutRatewareTariffCodeList";

export class RatewareTariffCodeList extends AutogenLayoutRatewareTariffCodeList {

    override async onLoad() {
        this.sourceRatewareTariffCodeMasterfile.search();
    }
}
